export const seoClickChallan = {
    event: "Challan_seo_click",
    eventAction: "Challan_seo_click",
    eventCategory: "Challan_homepage"
};
